import React from "react";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Link } from "react-router-dom";
import { UserCog } from "lucide-react";

// Operator dropdown for client trucco/capelli sheets.
// kind: 'makeup' | 'hair' — used to filter team members by role.
export default function ArtistPicker({ kind, value, onChange, team = [], testid }) {
  const label = kind === "hair" ? "Operatore capelli" : "Operatore trucco";
  const icon = kind === "hair" ? "✂️" : "💄";
  // Show members whose role matches the kind, or "both"
  const eligible = team.filter((m) => {
    const r = (m.role || "").toLowerCase();
    if (r === "both") return true;
    if (kind === "makeup") return r === "makeup" || r === "makeup_artist";
    if (kind === "hair") return r === "hair" || r === "hairstylist";
    return false;
  });

  return (
    <div className="bg-white border border-border rounded-sm p-5" data-testid={testid}>
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <span className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center shrink-0 text-base">
            {icon}
          </span>
          <div className="min-w-0">
            <Label className="label-uppercase">{label}</Label>
            <p className="text-xs text-neutral-500 mt-0.5">
              Assegna un membro del team per il calendario.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 min-w-[260px]">
          <Select value={value || "_none"} onValueChange={(v) => onChange(v === "_none" ? "" : v)}>
            <SelectTrigger className="rounded-sm flex-1" data-testid={`${testid}-select`}>
              <SelectValue placeholder="Non assegnato" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="_none">Non assegnato</SelectItem>
              {eligible.length === 0 ? (
                <SelectItem value="_empty" disabled>
                  Nessun operatore disponibile
                </SelectItem>
              ) : (
                eligible.map((m) => (
                  <SelectItem key={m.id} value={m.id}>
                    <span className="inline-flex items-center gap-2">
                      {m.color && (
                        <span
                          className="w-2.5 h-2.5 rounded-full inline-block"
                          style={{ backgroundColor: m.color }}
                        />
                      )}
                      {m.name}
                    </span>
                  </SelectItem>
                ))
              )}
            </SelectContent>
          </Select>
          <Link
            to="/app/team"
            className="text-xs text-primary hover:underline inline-flex items-center gap-1 shrink-0"
            data-testid={`${testid}-manage-link`}
            title="Gestisci team"
          >
            <UserCog className="w-3.5 h-3.5" strokeWidth={1.5} />
            <span className="hidden sm:inline">Team</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
